import React from 'react';
import { Card } from 'antd';
import { WeaVideo } from 'ecCom';
class Content_video_prew extends React.Component {
    render() {
        const{ title, imgSrc, fontSize, showTitle } = this.props;
        return (
            <div style={{padding: '0px', position: 'relative', width: '230px'}}>
                <div style={{position: 'relative', zIndex: 1}}>
                    {/*<WeaVideo options={{*/}
                        {/*video: [[imgSrc, "中文高清", 0]]*/}
                    {/*}} style={{width: '230px', height: '150px', verticalAlign: 'middle'}}/>*/}
                    <video src={imgSrc} ref={this.vidRef} style={{width: '230px', height: '150px', verticalAlign: 'middle'}} height={'150px'} loop="loop" controlsList="nodownload" controls="controls"></video>
                </div>
                <div style={{zIndex: 3, bottom: 0, color: 'black', height: '35px' ,lineHeight: '35px', textAlign: 'center' ,width: '100%',
                    fontSize: fontSize + 'px', overflow: 'hidden', textOverflow: 'ellipsis', wordBreak: 'normal', whiteSpace: 'nowrap'}}>{showTitle=='1'?title: ''}</div>
            </div>
        );
    }
}

export default Content_video_prew;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_video_prew.js